import { Symbol } from './Symbol';
import { smallCircle } from 'app/agriculture/icons/utils/map-icon-utils/billboard-icon-parts/smallCircle';

interface BillboardSmallCircleProps {
    color: string;
    shouldIncludeBorder: boolean;
    borderColor: string;
}
export function BillboardSmallCircle({
    color,
    shouldIncludeBorder,
    borderColor,
}: BillboardSmallCircleProps) {
    const symbol = Symbol({ icon: smallCircle, strokeWidth: 24 });
    const use = `
        <use
            href="#${smallCircle.id}"
            x="128"
            y="96"
            width="128"
            height="192"
            fill="${color}"
            stroke="${shouldIncludeBorder ? borderColor : color}"
        />`;

    return symbol + use;
}
